import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import TablaCodificacionAjusteCompromiso from "./tablaCodificacionAjusteCompromiso";
import CatalogoProveedorPresupuesto from "../../catalogos/catalogoProveedorm";
import CatalogoUnidadEjecutora from "../../catalogos/catalogoUnidadEjecutora";
import CatalogoCompromisosUbicacion from "../../catalogos/catalogoCompromisosUbicacion";
import CatalogoSPagoNomiAprob from "../../catalogos/catalogoSPagoNomiAprob";
import CatalogoFondoAvanceAprob from "../../catalogos/catalogoFondoAvanceAprob";
import CatalogoObrasAsignada from "../../catalogos/catalogoObrasAsignada";
import { validaSoloNumero, formatMoneda } from "../../util/varios";
import ValidarUsuario from "../comun/modalValidarUsuario";
import { CambiodeDatos } from "../comun/modalCambiodDatos";
import { numeroaLetra } from "../../util/NumeroaLetra";
import {
  DangerButton,
  InfoButton,
  SuccessButton,
} from "../../ui/buttons/Button";
import { Input, SearchInput, Select, Textarea } from "../../ui/inputs/Input";

export const AjustarCompromiso = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const anioefis = JSON.parse(localStorage.getItem("efiscalanio"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const ip = JSON.parse(localStorage.getItem("ip"));
  const mac = JSON.parse(localStorage.getItem("mac"));
  const liquidador = JSON.parse(localStorage.getItem("liquidador"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habiCod, setHabicod] = useState(true);
  const [habicat, setHabicat] = useState(true);
  const [habicatb, setHabicatb] = useState(true);
  const [habiProv, setHabiProv] = useState(false);
  const [habiUni, setHabiUni] = useState(false);
  const [habiConcep, setHabiConcep] = useState(false);
  const [habiFecha, setHabiFecha] = useState(false);
  const [habitipoc, setHabitipoc] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [datospre, setDatospre] = useState([]);
  const [condicion, setCondicion] = useState([]);
  const [valida, setValida] = useState(0);
  const [validat, setValidat] = useState(0);
  const [val, setVal] = useState(0.0);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [mostrar6, setMostrar6] = useState(false);
  const [mostrar7, setMostrar7] = useState(false);
  const [mostrar8, setMostrar8] = useState(false);
  const [mostrar9, setMostrar9] = useState(false);
  const [mostrarUsuario, setMostrarUsuario] = useState(false);
  const [montoCompro, setMontoCompro] = useState(0.0);
  const [montoIva, setMontoIva] = useState(0.0);
  const [deshabi, setDeshabi] = useState(true);
  const [vt, setVt] = useState(0);
  const [modifi, setModifi] = useState(false);
  const [proce, setProce] = useState(false);
  const [cat, setCat] = useState(0);
  const [tipo, setTipo] = useState(0);
  const [data, setData] = useState([]);
  const [cambioDatos, setCambioDatos] = useState(false);
  const [body, setBody] = useState(null);
  const [codigo, setCodigo] = useState(0);
  const [validatipo, setValidatipo] = useState(0);
  const [chek, setChek] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const [ultimo, setUltimo] = useState(false);
  const [estatus, setEstatatus] = useState(1);
  const [tipoOrden, setTipoOrden] = useState(0);
  const [exento, setExento] = useState(false);
  const [desde, setDesde] = useState(0);
  const [idPreComp, setIdPreComp] = useState(0);
  const [monaCompro, setMonaCompro] = useState(0.0);
  const [fecha, setFecha] = useState(null);
  const [fechaRev, setFechaRev] = useState(null);
  const [llamado, setLlamado] = useState(0);
  const [cambiarDatos, setCambiarDatos] = useState(false);
  const [idcta, setIdCta] = useState(0);
  const [idctan, setIdCtaN] = useState(0);
  const [idmov, setIdMov] = useState(0);
  const [fechaRef, setFechaRef] = useState(null);
  const [cuentas, setCuentas] = useState(0);
  const txtCodigo = useRef();
  const txtIdCompromiso = useRef();
  const txtFechaAjuste = useRef();
  const txtObservacionAjuste = useRef();
  const txtFecha = useRef();
  const txtFechaAprobacion = useRef();
  const txtFechaReverso = useRef();
  const txtObservacion = useRef();
  const txtNp = useRef();
  const txtNombreOr = useRef();
  const txtNTraslado = useRef();
  const txtIdprov = useRef();
  const txtCedurifprov = useRef();
  const txtNombreprov = useRef();
  const txtIdCoordinacion = useRef();
  const txtNombreUnidad = useRef();
  const txtTipoCompromiso = useRef();
  const txtReferencia = useRef();
  const txtConcepto = useRef();
  const txtMontoComprometer = useRef();
  const txtMontoAjuste = useRef();
  const txtMontoCompromiso = useRef();
  const txtMontoFondo = useRef();

  const onChange = (e) => {
    if (
      e.target.name === "descriaux" ||
      e.target.name === "ubicacion" ||
      e.target.name === "observacion" ||
      e.target.name === "observacionajuste"
    ) {
      e.target.value = e.target.value.toUpperCase();
    }

    if (e.target.name === "tipo") {
      txtConcepto.current.value = "";
      txtObservacion.current.value = "";
      txtIdCoordinacion.current.value = "";
      txtNombreUnidad.current.value = "";
      txtIdprov.current.value = "";
      setExento(false);
      txtCedurifprov.current.value = "";
      txtNombreprov.current.value = "";
      //txtMontoComprometer.current.value = '0,00';
      txtMontoAjuste.current.value = "0,00";
      setMonaCompro(0.0);
      txtReferencia.current.value = "";
      setDeshabilitado(false);
      /*setHabiprov(false);*/
      setDatospre([]);
      setIdPreComp(0);
      if (e.target.value === "1") {
        setHabicat(false);
        setHabicatb(false);
        setHabiProv(true);
        setHabiUni(true);
        setHabiConcep(true);
        setValidatipo(e.target.value);
        setTipo(5); // ORDEN DE COMPRA
        setTipoOrden(0);
        setEstatatus(1);
        setDeshabi(true);
        //txtReferencia.current.value = '';
      } else if (e.target.value === "2") {
        setValidatipo(e.target.value);
        setHabicat(false);
        setHabicatb(false);
        setHabiProv(true);
        setHabiUni(true);
        setHabiConcep(true);
        setTipo(7); // PAGO DE OBRAS
        setDeshabi(true);
        //txtReferencia.current.value = '';
      } else if (e.target.value === "3") {
        setValidatipo(e.target.value);
        setTipo(11); // ORDEN DE SERVICIO
        setHabicat(false);
        setHabicatb(false);
        setHabiProv(true);
        setHabiUni(true);
        setHabiConcep(true);
        setTipoOrden(1);
        setEstatatus(1);
        setDeshabi(true);
        //txtReferencia.current.value = '';
      } else if (e.target.value === "4") {
        setTipo(12); // PAGO DIRECTO
        setValidatipo(e.target.value);
        setHabicat(true);
        setHabicatb(true);
        setHabiProv(false);
        setHabiUni(false);
        setHabiConcep(false);
        setDeshabi(false);
        setDeshabilitado(false);
        //txtReferencia.current.value = '';
      } else if (e.target.value === "5") {
        setTipo(13); // PAGO DE NOMINA
        setValidatipo(e.target.value);
        setHabicatb(false);
        setHabicat(false);
        setHabiProv(false);
        setHabiUni(false);
        setHabiConcep(true);
        setDeshabi(false);
        //txtReferencia.current.value = '';
      } else if (e.target.value === "6") {
        setTipo(23); // FONDO EN AVANCE
        setValidatipo(e.target.value);
        setHabicatb(false);
        setHabicat(false);
        setDeshabi(true);
        setHabiProv(true);
        setHabiConcep(false);
        setHabiUni(false);
        //txtReferencia.current.value = '';
      } else if (e.target.value === "7") {
        setTipo(24); // FONDO EN ANTICIPO
        setValidatipo(e.target.value);
        setHabicatb(false);
        setHabicat(false);
        setDeshabi(true);
        //txtReferencia.current.value = '';
      } else if (e.target.value === "8") {
        setValidatipo(e.target.value);
        setHabicat(true);
        setHabiProv(true);
        setHabiUni(true);
        setHabiConcep(true);
        setDeshabi(true);
        //txtReferencia.current.value = '';
      } else if (e.target.value === "9") {
        setTipo(26); // ORDEN DE DONACION
        setValidatipo(e.target.value);
        setHabicat(false);
        setHabicatb(false);
        setHabiProv(true);
        setHabiUni(true);
        setHabiConcep(true);
        setTipoOrden(2);
        setEstatatus(1);
        setDeshabi(true);
        //txtReferencia.current.value = '';
      } else {
        setHabicat(true);
        setHabiProv(true);
        setHabiUni(true);
        setHabiConcep(true);
        //txtReferencia.current.value = '';
      }
    } else if (e.target.name === "idcompromiso") {
      txtFecha.current.value = "";
      txtConcepto.current.value = "";
      txtObservacion.current.value = "";
      txtIdCoordinacion.current.value = "";
      txtNombreUnidad.current.value = "";
      txtIdprov.current.value = "";
      setExento(false);
      txtCedurifprov.current.value = "";
      txtNombreprov.current.value = "";
      //txtMontoComprometer.current.value = '0,00';
      txtMontoAjuste.current.value = "0,00";
      setMonaCompro(0.0);
      if (txtMontoFondo && txtMontoFondo.current) {
        txtMontoFondo.current.value = "0,00";
      }
      /*setDeshabilitado(false);
            setHabiprov(false);*/
      setDatospre([]);
    }
  };

  const handleCompromiso = (e) => {
    if (e.which === 13 || typeof e.which === "undefined") {
      if (e.target.value.trim() !== "") {
        seleccionarCompromiso(e.target.value, 4);
      }
    }
  };

  const seleccionarReferencia = (tip, ope) => {
    let sigue = false;
    setFechaRef(null);
    switch (tip) {
      case 5:
      case 11:
      case 26:
        seleccionarOrdenCompra(txtReferencia.current.value, ope, tip);
        break;
      case 7:
        seleccionarSolicitudPagoObra(txtReferencia.current.value, ope);

        break;
      case 13:
        seleccionarSPagoNomina(txtReferencia.current.value, ope);

        break;
      case 23:
        seleccionarFondoAvance(txtReferencia.current.value, ope);

        break;
      /*case 24:
                lblTipo.setText("Monto Fondo Anticipo");
                sigue = seleccionarFondoAvance(bloq);
                if (sigue) {
                    btnAgregar1.setEnabled(true);
                    btnEliminar1.setEnabled(true);
                }
                break;
            case 26:
1                sigue = seleccionarOrdenDonacion(bloq);
                if (sigue) {
                    if (idPreComp == 0) {
                        btnAgregar1.setEnabled(true);
                        btnEliminar1.setEnabled(true);
                    } else {
                        btnAgregar1.setEnabled(false);
                        btnEliminar1.setEnabled(false);
                    }
                    if (operacion == 1) {
                        txtIdCoordinacion.current.value = response.data.idcoordinacion;
                        //Event evt = new Event();
                        //evt.keyCode = SWT.CR;
                        //txtIdCoordinacion.notifyListeners(SWT.KeyUp, evt);
                    }


                }
                break;*/
    }
  };

  const seleccionarOrdenCompra = (id, ope, tip) => {
    setActivate(true);
    let nomid = "";
    if (tip === 26) {
      nomid = "idordendonacion";
    } else {
      nomid =
        espiritu == 8 ||
        espiritu == 9 ||
        espiritu == 12 ||
        espiritu == 14 ||
        espiritu == 15
          ? tip === 5
            ? "idordencompra"
            : "idordenservicio"
          : "idordencompra";
    }

    let endpoint = `${op.conexion}/api/presupuesto/seleccionarordencompra?idefi=${idefiscal}&operacion=${ope}&nomid=${nomid}&referencia=${id}&espiritu=${espiritu}&tipo=${tipo}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setIdPreComp(response.data[0].idprecompro);
            setFechaRef(response.data[0].fecrefe);
            /*btnAgregar1.setEnabled(true);
                    btnEliminar1.setEnabled(true);*/
            if (ope === 1) {
              if (response.data[0].idcuenta > 0) {
                setDeshabi(true);
                setValida(1);
              } else {
                setDeshabi(false);
                setValida(0);
              }
              txtIdCoordinacion.current.value = response.data[0].idcordinacion;
              seleccionarUnidadEjecutora(response.data[0].idcordinacion);
              txtIdprov.current.value = response.data[0].idproveedor;
              seleccionarProveedor(response.data[0].idproveedor);
              txtObservacion.current.value =
                response.data[0].observaciones === null
                  ? ""
                  : response.data[0].observaciones.trim();
              txtConcepto.current.value = response.data[0].concepto.trim();
              setDeshabilitado(true);
              setHabiProv(true);
              setHabiUni(true);
              setHabiConcep(true);
              //txtMontoComprometer.current.value = formatMoneda(response.data[0].nmonacomprometer.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              txtMontoCompromiso.current.value = formatMoneda(
                response.data[0].monto
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              setMonaCompro(response.data[0].nmonacomprometer);
              setDatospre(response.data);
              setMontoIva(response.data[0].montoiva);
              //setIdPreComp(response.data[0].idprecompro);
              //Event evt = new Event();
              //evt.keyCode = SWT.CR;
              //txtIdCoordinacion.notifyListeners(SWT.KeyUp, evt);
            }
          } else {
            console.log("no hay registros");
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarSolicitudPagoObra = (id, ope) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/seleccionarpagoobra?idefi=${idefiscal}&operacion=${ope}&referencia=${id}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            //setFechaRef(response.data[0].fecrefe);
            if (ope === 1) {
              if (response.data[0].idcuenta > 0) {
                setDeshabi(true);
                setValida(1);
              } else {
                setDeshabi(false);
                setValida(0);
              }
              txtIdprov.current.value = response.data[0].idproveedor;
              seleccionarProveedor(response.data[0].idproveedor);
              txtConcepto.current.value = response.data[0].concepto.trim();
              setDeshabilitado(true);
              setHabiProv(true);
              setHabiUni(false);
              setHabiConcep(true);
              //txtMontoComprometer.current.value = formatMoneda(response.data[0].nmonacomprometer.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              setMonaCompro(response.data[0].nmonacomprometer);
              setDatospre(response.data);
              setMontoIva(response.data[0].montoiva);
              //setIdPreComp(response.data[0].idprecompro);
              //Event evt = new Event();
              //evt.keyCode = SWT.CR;
              //txtIdCoordinacion.notifyListeners(SWT.KeyUp, evt);
            }
          } else {
            console.log("no hay registros");
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarSPagoNomina = (id, ope) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/seleccionarpagonomina?idefi=${idefiscal}&operacion=${ope}&referencia=${id}&espiritu=${espiritu}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            //setIdPreComp(response.data[0].idprecompro);
            setFechaRef(response.data[0].fecrefe);
            if (ope === 1) {
              if (response.data[0].idcuenta > 0) {
                setDeshabi(true);
                setValida(1);
              } else {
                setDeshabi(false);
                setValida(0);
              }

              //txtObservacion.current.value = response.data[0].observaciones;
              txtConcepto.current.value = response.data[0].concepto.trim();
              setDeshabilitado(true);
              //setHabiprov(false);
              //txtMontoComprometer.current.value = formatMoneda(response.data[0].nmonacomprometer.toString().replace(',', '').replace('.', ','), ',', '.', 2);
              setMonaCompro(response.data[0].nmonacomprometer);
              setDatospre(response.data);
              setMontoIva(response.data[0].montoiva);
              //setIdPreComp(response.data[0].idprecompro);
              //Event evt = new Event();
              //evt.keyCode = SWT.CR;
              //txtIdCoordinacion.notifyListeners(SWT.KeyUp, evt);
            }
          } else {
            console.log("no hay registros");
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarFondoAvance = (id, ope) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/seleccionarfondoavance?idfondo=${id}&idefi=${idefiscal}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            setFechaRef(response.data.fecha);
            if (tipo === 23) {
              if (response.data.tipofondo === 1) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "El Fondo en Avance no existe",
                  icono: "informacion",
                });
                txtReferencia.current.value = "";
                txtReferencia.current.focus();
                return;
              }
            } else if (tipo === 24) {
              if (response.data.tipofondo === 0) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "El Fondo en Anticipo no existe",
                  icono: "informacion",
                });
                txtReferencia.current.value = "";
                txtReferencia.current.focus();
                return;
              }
            }
            if (ope === 1) {
              setDeshabi(false);
              setValida(0);

              txtObservacion.current.value =
                response.data.descripcion === null
                  ? ""
                  : response.data.descripcion.trim();
              //txtConcepto.current.value = response.data[0].concepto;
              setDeshabilitado(true);
              //setHabiprov(false);
              //txtMontoComprometer.current.value = '0,00';
              txtMontoFondo.current.value = formatMoneda(
                response.data.montoaenterar
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              setMonaCompro(response.data.montoaenterar);
              txtIdprov.current.value = response.data.idorganismo;
              seleccionarProveedor(response.data.idorganismo);
              setDatospre(response.data);
              setMontoIva(0.0);
              //setIdPreComp(response.data[0].idprecompro);
              //Event evt = new Event();
              //evt.keyCode = SWT.CR;
              //txtIdCoordinacion.notifyListeners(SWT.KeyUp, evt);
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto:
                "El Fondo en " +
                (tipo === 23 ? "Avance " : "Anticipo ") +
                "no existe",
              icono: "informacion",
            });
            txtReferencia.current.value = "";
            txtReferencia.current.focus();
            console.log("no hay registros");
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarOrdenDonacion = (id) => {
    setActivate(true);
    let idval = "idordencompra";

    let endpoint = `${op.conexion}/api/presupuesto/seleccionarordendonacion?idval=${idval}&id=${id}&idefiscal=${idefiscal}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idordencompra > 0) {
            console.log(response.data);
          } else {
            console.log("no hay registros");
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El código del Ajuste de Compromiso no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtIdprov.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El código del Compromiso debe ser valido",
        icono: "informacion",
      });
      sigue = false;
      txtIdCompromiso.current.focus();
    } else if (txtFechaAjuste.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La fecha del ajuste de compromiso no es valida",
        icono: "informacion",
      });
      sigue = false;
      txtFechaAjuste.current.focus();
    } else if (
      new Date(txtFechaAjuste.current.value).getFullYear() !== anioefis
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "El año no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFechaAjuste.current.focus();
    } else if (txtObservacionAjuste.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Observacion del Ajuste no puede estar en blanco",
        icono: "informacion",
      });
      sigue = false;
      txtObservacionAjuste.current.focus();
    } else if (valida !== 1) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No existen cuentas presupuestaria para el compromiso",
        icono: "informacion",
      });
      sigue = false;
    } else if (txtFechaAjuste.current.value < txtFecha.current.value) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "La Fecha del Ajuste no Puede ser Anterior a la Fecha del Compromiso",
        icono: "informacion",
      });
      sigue = false;
      txtFechaAjuste.current.focus();
    }

    if (sigue) {
      let datosaju = [];
      let datoscue = [];
      datosaju.push({
        idcompro: txtIdCompromiso.current.value,
        referencia: txtReferencia.current.value,
        observ: txtObservacionAjuste.current.value,
        montocompro: montoCompro,
        montoaju: parseFloat(
          txtMontoAjuste.current.value.trim().replace(/\./g, "").replace(",", ".")
        ),
        fechaaju: txtFechaAjuste.current.value,
      });
      var datacue = props.operacion === 1 ? [...data] : [...cuentas];
      for (let i = 0; i < datacue.length; i++) {
        datoscue.push({
          m_nIdCta: datacue[i].idcuenta,
          m_cAux: datacue[i].auxiliar,
          m_nMonto: datacue[i].monto,
          m_nMontoCausado: datacue[i].montocausado,
          m_nMontoAjustado: datacue[i].montoajustado,
          m_nMontoAjuste: datacue[i].montoajuste,
          m_nIdCatPro: datacue[i].idcat,
          m_nIdPuc: datacue[i].idpuc,
          m_nIdPreCompro: idPreComp,
          m_nIdMov: datacue[i].idmovimiento,
          m_nIdMovc: data[i].idmovimiento,
        });
      }

      setBody({
        operacion: props.operacion,
        idaju: txtCodigo.current.value,
        idefi: idefiscal,
        idusuario: idusuario,
        tipo: tipo,
        fecha: txtFechaAjuste.current.value,
        espiritu: espiritu,
        datosaju: datosaju,
        datoscuenta: datoscue,
      });

      let msg = "";
      setDesde(0);
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar este Ajuste de Compromiso?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Reversar este Ajuste de Compromiso?.";
      } else if (props.operacion === 5) {
        msg = "Esta Seguro de Eliminar este Ajuste de Compromiso?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/crearreversarajustecompromiso`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          /*setDesde(2);
                setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Desea Imprimir En este Momento el Ajuste de Compromiso?', icono: 'confirmacion' });*/
          if (props.operacion === 1) {
            //setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Compromiso Registrado Correctamente', icono: 'exito' });
            setDesde(2);
            setMensajesino({
              mostrar: true,
              titulo: "Confirmación.",
              texto: "Desea Imprimir En este Momento el Ajuste de Compromiso?",
              icono: "confirmacion",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El Ajuste de Compromiso " +
                txtCodigo.current.value +
                " Fué Eliminado",
              icono: "exito",
            });
          } else if (props.operacion === 5) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Eliminado Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarModificarConcepto = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (
      new Date(txtFecha.current.value).getFullYear() !== anioefis
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "El año no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (txtConcepto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Decriba el Concepto o Detalle",
        icono: "informacion",
      });
      sigue = false;
      txtConcepto.current.focus();
    }

    if (sigue) {
      let nomid = "";
      if (tipo === 26) {
        nomid = "idordendonacion";
      } else {
        nomid =
          espiritu == 8 ||
          espiritu == 9 ||
          espiritu == 12 ||
          espiritu == 14 ||
          espiritu == 15
            ? tipo === 5
              ? "idordencompra"
              : "idordenservicio"
            : "idordencompra";
      }
      let body = {
        idcompro: codigo,
        idcompronue: txtCodigo.current.value,
        concep: txtConcepto.current.value,
        dfecha: txtFecha.current.value,
        idefi: idefiscal,
        tipo: tipo,
        nomid: nomid,
        referencia: txtReferencia.current.value,
        idusu: idusuario,
        fechasis: fechaSistema,
        dirip: ip,
        dirmac: mac,
      };

      procesarCambio(body);
    }
  };

  const procesarCambio = (body) => {
    let endpoint = `${op.conexion}/api/presupuesto/modificarconceptocompromiso`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Se Generaron Cambios Satisfactoriamente",
            icono: "exito",
          });
          setModifi(true);
          setProce(false);
          setHabiConcep(true);
          setHabiFecha(true);
          setHabicod(true);
          setCambioDatos(true);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarModificarFechaReverso = (fecha) => {
    //setDesde(1);
    setMensajesino({
      mostrar: true,
      titulo: "Confirmación.",
      texto: "Está Seguro de Cambiar la Fecha de Reverso del Compromiso?",
      icono: "confirmacion",
    });
  };

  const procesarCambioFechaReverso = () => {
    let body = {
      idcompro: txtCodigo.current.value,
      dfecha: fechaRev,
      idefi: idefiscal,
      idusu: idusuario,
      fechasis: fechaSistema,
      dirip: ip,
      dirmac: mac,
    };

    let endpoint = `${op.conexion}/api/presupuesto/modificarfechareversocompromiso`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          txtFechaReverso.current.value = moment.utc(fechaRev).format("YYYY-MM-DD");
          setFecha(fechaRev);
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Se Generaron Cambios Satisfactoriamente",
            icono: "exito",
          });
          setCambioDatos(true);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    if (cambioDatos) {
      blanquear();
      props.onHideRenderizar();
      props.onHideCancelar();
    } else {
      blanquear();
      props.onHideCancelar();
    }
  };

  const imprimiAjusteCompromiso = () => {
    var reporte = "ForAjusteCompromiso";

    var sql = "";
    var sql1 = "";
    var sql2 = "1";
    var sql3 = "";
    var vali = "0";

    if (tipo === 7) {
      sql2 = "0";
    }
    sql =
      "AJU.idajustecompromiso  in ('" +
      txtCodigo.current.value +
      "')" +
      " AND CPG.IDEFISCAL = " +
      idefiscal +
      " AND MXC.IDEFISCAL = " +
      idefiscal +
      " AND AJU.IDEFISCAL =" +
      idefiscal;

    var monto = formatMoneda(
      montoCompro.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    sql1 = numeroaLetra(monto.trim().replace(/\./g, "")) + " Bs.";
    if (tipo == 5 || tipo == 11) {
      sql3 =
        "CPG.referencia = " +
        (idefiscal === 8 ||
        idefiscal === 9 ||
        idefiscal === 12 ||
        idefiscal === 14
          ? tipo == 5
            ? "ORC.idordencompra"
            : "ORC.idordenservicio"
          : "ORC.idordencompra") +
        " AND ORC.IDEFISCAL =" +
        idefiscal;
    } else {
      sql3 = "1 = 2";
    }
    var reversada =
      props.compro && props.compro.reversado > 0
        ? "¡ El Compromiso está Reversado !"
        : "";

    window.open(
      op.reportes +
        "reporte=" +
        reporte +
        "&ID=" +
        sql +
        "&ENLETRAS=" +
        sql1 +
        "&DESCRIPTOR=" +
        sql2 +
        "&CONDICION=" +
        sql3 +
        "&REVERSADA=" +
        reversada +
        "&USUARIO=" +
        liquidador.trim() +
        "&VIENE=" +
        espiritu +
        "&VALIDO=" +
        vali,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setDatospre([]);
    setActivate(false);
    setChek(0);
    setValida(0);
    setVal(0.0);
    setMontoCompro(0.0);
    setCat(0);
    setProce(false);
    setModifi(false);
    setData([]);
    setBody(null);
    setCodigo(0);
    setValidat(0);
    setHabicat(true);
    setHabiProv(false);
    setHabiUni(false);
    setHabiConcep(false);
    setHabiFecha(false);
    setDeshabilitado(false);
    setIdPreComp(0);
    setHabicod(false);
    setCambioDatos(false);
    setFechaRef(null);
    setIdCta(0);
    setIdCtaN(0);
    setIdMov(0);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
      procesarCambioFechaReverso();
    } else if (desde === 2) {
      imprimiAjusteCompromiso();
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto:
          "El Ajuste de Compromiso " +
          txtCodigo.current.value +
          " fué creado Exitosamente",
        icono: "exito",
      });
    } else if (desde === 3) {
      /*var reporte = '';
            if (espiritu === 9 || espiritu === 12 ){
                reporte = 'ForCompromisoAraure';	
            } else if (espiritu === 14) {
                reporte = 'ForCompromisoUnda';
            }else {
                reporte = 'ForCompromiso.jasper';
            }
            var sql = '';
            var sql2 = '1';
            if (tipo === 7) {
                sql2 = '0';
            }
            sql = 'CPG.IdCompromiso=' + txtCodigo.current.value + ' AND CPG.IDEFISCAL = ' + idefiscal + ' AND MXC.IDEFISCAL = ' + idefiscal;
            var sql3 = 'AND CPG.IDEFISCAL = ' + idefiscal;
            var vali = '0';
            var condicion = '';
           
            condicion = sql;
            window.open(op.reportes + "reporte=" + reporte + "&CONDICION=" + condicion + "&DESCRIPTOR=" + sql2 + "&ORDENEFIS=" + sql3 + "&USUARIO=" + liquidador.trim() + "&VIENE=" + espiritu + "&VALIDO=" + vali , "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");*/
      imprimiAjusteCompromiso();
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto:
          "El Ajuste de Compromiso " +
          txtCodigo.current.value +
          " fué creado Exitosamente",
        icono: "exito",
      });
    } else {
      Actualizar();
    }
  };

  const handleCloseNo = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 2) {
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto:
          "El Ajuste de Compromiso " +
          txtCodigo.current.value +
          " fué creado Exitosamente",
        icono: "exito",
      });
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    //setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const BaseDatos = (data, moniva, idcuenta, idcuentan, idmovimiento) => {
    if (props.operacion === 1) {
      if (data && data.length > 0) {
        setValida(1);
        setVt(1);
        let total = 0.0;
        let totalaju = 0.0;
        for (let i = 0; i < data.length; i++) {
          total = parseFloat(total) + parseFloat(data[i].monto);
          totalaju = parseFloat(totalaju) + parseFloat(data[i].montoajuste);
        }

        setMontoCompro(
          Math.round(parseFloat(total) * Math.pow(10, 4)) / Math.pow(10, 4)
        );
        txtMontoAjuste.current.value = formatMoneda(
          totalaju.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
        if (tipo == 12 || tipo == 23 || props.operacion == 4 || tipo == 24) {
          //txtMontoComprometer.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        }
      }

      setMontoIva(
        Math.round(parseFloat(moniva) * Math.pow(10, 4)) / Math.pow(10, 4)
      );
    }
    setData(data);
    setIdCta(idcuenta);
    setIdCtaN(idcuentan);
    setIdMov(idmovimiento);
  };

  const catalogoOrganismo = (e) => {
    e.preventDefault();
    setMostrar3(true);
  };

  const catalogoProveedor = (e) => {
    e.preventDefault();
    setMostrar4(true);
  };

  const catalogoCompromiso = (e) => {
    e.preventDefault();
    setMostrar5(true);
  };

  const handleCancelara = () => {
    setMostrar3(false);
  };

  const handleCancelaProveedor = () => {
    setMostrar4(false);
  };

  const handleCancelaCompromisos = () => {
    setMostrar5(false);
  };

  const handleCancelaObra = () => {
    setMostrar8(false);
  };

  const handleCancelaSpagosNomi = () => {
    setMostrar6(false);
  };

  const handleCancelaFondos = () => {
    setMostrar7(false);
  };

  const handleAceptaUnidadEjecutora = (
    idcoordinacion,
    nombre,
    iddireccion,
    encargado
  ) => {
    setMostrar3(false);

    txtIdCoordinacion.current.value = idcoordinacion;
    txtNombreUnidad.current.value = nombre.trim();
  };

  const handleAceptarProveedor = (
    responsable,
    razonsocial,
    idproveedor,
    rif
  ) => {
    setMostrar4(false);

    txtIdprov.current.value = idproveedor;
    seleccionarProveedor(idproveedor);
    /*txtCedurifprov.current.value = rif;
        txtNombreprov.current.value = razonsocial.trim();*/
  };

  const handleAceptarCompromisos = (
    idcompromiso,
    tipo,
    referencia,
    fecha,
    idproveedor,
    idcoordinacion,
    idefiscal,
    concepto,
    reversado,
    montocompromiso,
    ubicacion,
    status,
    montoiva,
    fechafactura,
    nrofactura,
    nrocontrol,
    idusuario_crea,
    fecha_crea,
    fecha_reverso,
    idusuario_reversa,
    idtipopago,
    iddatpresu
  ) => {
    setMostrar5(false);
    seleccionarCompromiso(idcompromiso, 4);
  };

  const seleccionarCompromiso = (id, ope) => {
    let endpoint = `${op.conexion}/api/presupuesto/seleccionarcompromiso?idefi=${idefiscal}&operacion=${ope}&&idcompro=${id}&espiritu=${espiritu}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            /*setCompromiso(response.data[0]);
                    setCuentas(response.data);
                    setMostrar2(true);*/
            if (props.operacion === 1) {
              if (response.data[0].reversado === 1 && props.operacion !== 4) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "El compromiso ya fue reversado",
                  icono: "informacion",
                });
                txtIdCompromiso.current.value = "";
                txtIdCompromiso.current.focus;
                setActivate(false);
                return;
              } else if (
                response.data[0].status === 1 &&
                props.operacion !== 4
              ) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "El compromiso ya fue causado",
                  icono: "informacion",
                });
                txtIdCompromiso.current.value = "";
                txtIdCompromiso.current.focus;
                setActivate(false);
                return;
              } else if (
                response.data[0].status === 2 &&
                props.operacion !== 4
              ) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "El compromiso ya fue pagado",
                  icono: "informacion",
                });
                txtIdCompromiso.current.value = "";
                txtIdCompromiso.current.focus;
                setActivate(false);
                return;
              } else if (
                response.data[0].ubicacion !== "42" &&
                props.operacion !== 4
              ) {
                setMensaje({
                  mostrar: true,
                  titulo: "Informacion.",
                  texto: response.data[0].mensajeubi,
                  icono: "informacion",
                });
                setActivate(false);
                return;
              } else {
                var majustar = 0.0;
                var mcausado = 0.0;
                for (let i = 0; i < response.data.length; i++) {
                  majustar =
                    majustar +
                    (response.data[i].monto -
                      response.data[i].montocausado -
                      response.data[i].montoajustado);
                  mcausado = mcausado + response.data[i].montocausado;
                }
                if (majustar === 0) {
                  setMensaje({
                    mostrar: true,
                    titulo: "Notificación",
                    texto: "El Compromiso no tiene monto para ajustar",
                    icono: "informacion",
                  });
                  txtIdCompromiso.current.value = "";
                  txtIdCompromiso.current.focus;
                  setActivate(false);
                  return;
                }
                txtIdCompromiso.current.value = response.data[0].idcompromiso;
                //setCodigo(response.data[0].idcompromiso);
                //txtMontoComprometer.current.value = formatMoneda(response.data[0].montocompromiso.toString().replace(',', '').replace('.', ','), ',', '.', 2);

                txtFechaAjuste.current.focus();
                setDatospre(response.data);
              }
            } else {
              var cuen = [...response.data];
              for (let i = 0; i < cuen.length; i++) {
                cuen[i].montocausado = props.cuentas[i].monto;
                cuen[i].montoajuste = props.cuentas[i].monto;
              }
              setDatospre(cuen);
            }
            setMonaCompro(response.data[0].montocompromiso);
            setMontoCompro(response.data[0].montocompromiso);
            //setDatospre(props.movi);
            setTipo(response.data[0].tipo);
            if (response.data[0].tipo === 5) {
              txtTipoCompromiso.current.value = "1";
              setChek(1);
            } else if (response.data[0].tipo === 7) {
              txtTipoCompromiso.current.value = "2";
              setChek(2);
            } else if (response.data[0].tipo === 11) {
              txtTipoCompromiso.current.value = "3";
              setChek(3);
            } else if (response.data[0].tipo === 12) {
              txtTipoCompromiso.current.value = "4";
              setChek(4);
            } else if (response.data[0].tipo === 13) {
              txtTipoCompromiso.current.value = "5";
              setChek(5);
            } else if (response.data[0].tipo === 23) {
              txtTipoCompromiso.current.value = "6";
              setChek(6);
            } else if (response.data[0].tipo === 24) {
              txtTipoCompromiso.current.value = "7";
              setChek(7);
            } else if (response.data[0].tipo === 25) {
              txtTipoCompromiso.current.value = "8";
              setChek(8);
            } else if (response.data[0].tipo === 26) {
              txtTipoCompromiso.current.value = "9";
              setChek(9);
            }
            txtReferencia.current.value = response.data[0].referencia;
            txtFecha.current.value = moment.utc(response.data[0].fecha).format(
              "YYYY-MM-DD"
            );
            txtIdprov.current.value = response.data[0].idproveedor;
            seleccionarProveedor(response.data[0].idproveedor);
            txtIdCoordinacion.current.value = response.data[0].idcoordinacion;
            seleccionarUnidadEjecutora(response.data[0].idcoordinacion);
            txtConcepto.current.value = response.data[0].concepto.trim();
            txtObservacion.current.value = response.data[0].observacion.trim();

            //txtNombreOr.current.value = props.provee.razonsocial.trim();
            //txtNTraslado.current.value = '000' + response.data[0].codigo;
            //seleccionarReferencia(props.compro.tipo, props.operacion);

            setValida(1);
            setValidat(1);
            setDeshabi(true);
          } else {
            /*setCompromiso();
                    setCuentas();*/
            txtIdCompromiso.current.value = "";
            txtIdCompromiso.current.focus;
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        txtIdCompromiso.current.value = "";
        txtIdCompromiso.current.focus;
      });
  };

  const handleAceptarObra = (
    idobraasignada,
    descripcionobra,
    razonsocial,
    idobra,
    idproveedor
  ) => {
    txtReferencia.current.value = idobraasignada;

    seleccionarSolicitudPagoObra(txtReferencia.current.value, props.operacion);
    setMostrar8(false);
  };

  const handleAceptarSPagosNomi = (
    idsolicitudpagonomina,
    concepto,
    fechainicio
  ) => {
    txtReferencia.current.value = idsolicitudpagonomina;

    seleccionarSPagoNomina(txtReferencia.current.value, props.operacion);
    setMostrar6(false);
  };

  const handleAceptarFondos = (
    idfondo,
    descripcion,
    monto,
    responsable,
    tipofondo
  ) => {
    txtReferencia.current.value = idfondo;

    seleccionarFondoAvance(txtReferencia.current.value, props.operacion);
    setMostrar7(false);
  };

  const seleccionarProveedor = (codigo) => {
    let campos = "*";
    let nomtab = "proveedor";
    let nomid = "idproveedor";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idproveedor > 0) {
            txtIdprov.current.value = response.data.idproveedor;
            txtCedurifprov.current.value = response.data.rif;
            txtNombreprov.current.value = response.data.razonsocial;
            setExento(response.data.exentoiva);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleProveedor = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    txtCedurifprov.current.value = "";
    txtNombreprov.current.value = "";
    setDatospre([]);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarProveedor(event.target.value);
      }
    }
  };

  const seleccionarUnidadEjecutora = (id) => {
    let endpoint = `${op.conexion}/api/presupuesto/consultarunidadejecutora?id=${id}`;
    console.log(endpoint);
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idcoordinacion > 0) {
            txtIdCoordinacion.current.value = response.data.idcoordinacion;
            txtNombreUnidad.current.value = response.data.nombre;
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const handleUnidadEjecutora = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    txtNombreUnidad.current.value = "";
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarUnidadEjecutora(event.target.value);
      }
    }
  };

  const seleccionaUltimoId = () => {
    let campos = "idajustecompromiso";
    let nomtab = "ajustecompromiso";
    let condi = "idefiscal=" + idefiscal;
    let orden = "idajustecompromiso DESC LIMIT 1";

    let endpoint =
      op.conexion +
      `/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setUltimo(parseInt(response.data[0].idajustecompromiso));
            setHabicod(false);
            txtCodigo.current.value =
              parseInt(response.data[0].idajustecompromiso) + 1;
          } else {
            setUltimo(0);
            setHabicod(false);
            txtCodigo.current.value = 1;
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const handleInputNumChange = (event) => {
    //setActiveIndex(1);
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.id === "idcommpromiso") {
          txtTipoCompromiso.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const aceptaClaveSupervisor = () => {
    setMostrarUsuario(false);
    if (desde === 0) {
      setModifi(false);
      setProce(true);
      setHabiConcep(false);
      //setHabiFecha(false);
      //setHabicod(false);
    } else if (desde === 1) {
      setLlamado(3);
      setFecha(txtFechaReverso.current.value);
      setCambiarDatos(true);
      //setMensaje({ mostrar: true, titulo: 'Notificación.', texto: 'El registro va a ser Modificado', icono: 'informacion' });
    }

    //imprimirRecibo(factura.idfactura);
  };

  const aceptaCambioDatos = (codigo, fecha, llamado) => {
    setCambiarDatos(false);
    setFechaRev(fecha);
    if (llamado === 3) {
      validarModificarFechaReverso();
    }

    //imprimirRecibo(factura.idfactura);
  };

  const cambiarConcepto = () => {
    setDesde(0);
    setMostrarUsuario(true);
  };

  const cambiarFechaReverso = () => {
    setDesde(1);
    setMostrarUsuario(true);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (
          props.operacion === 4 ||
          props.operacion === 5 ||
          props.operacion === 2
        ) {
          setHabicod(true);
        } else {
          setHabicod(false);
        }
        if (props.operacion === 4) {
          setModifi(true);
        }
        if (props.operacion !== 1) {
          setHabiFecha(true);
          setHabiConcep(true);
          setValues(props.ajuste);
          txtCodigo.current.value = props.ajuste.idajuste;
          setCodigo(props.ajuste.idajuste);
          //txtMontoComprometer.current.value = formatMoneda(props.ajuste.montocompromiso.toString().replace(',', '').replace('.', ','), ',', '.', 2);
          setMonaCompro(props.ajuste.montocompromiso);
          setMontoCompro(props.ajuste.montocompromiso);
          txtFechaAjuste.current.value = moment.utc(
            props.ajuste.fechaajuste
          ).format("YYYY-MM-DD");
          txtObservacion.current.value = props.ajuste.observacion;
          txtIdCompromiso.current.value = props.ajuste.idcompromiso;
          txtMontoAjuste.current.value = props.ajuste.montoajuste;
          setCuentas(props.cuentas);
          seleccionarCompromiso(props.ajuste.idcompromiso, 4);
          //setDatospre(props.movi);
          /*setTipo(props.compro.tipo);
                    if (props.compro.tipo === 5) {
                        txtTipoCompromiso.current.value = '1';
                        setChek(1);
                    } else if (props.compro.tipo === 7) {
                        txtTipoCompromiso.current.value = '2';
                        setChek(2);
                    } else if (props.compro.tipo === 11) {
                        txtTipoCompromiso.current.value = '3';
                        setChek(3);
                    } else if (props.compro.tipo === 12) {
                        txtTipoCompromiso.current.value = '4';
                        setChek(4);
                    } else if (props.compro.tipo === 13) {
                        txtTipoCompromiso.current.value = '5';
                        setChek(5);
                    } else if (props.compro.tipo === 23) {
                        txtTipoCompromiso.current.value = '6';
                        setChek(6);
                    } else if (props.compro.tipo === 24) {
                        txtTipoCompromiso.current.value = '7';
                        setChek(7);
                    } else if (props.compro.tipo === 25) {
                        txtTipoCompromiso.current.value = '8';
                        setChek(8);
                    } else if (props.compro.tipo === 26) {
                        txtTipoCompromiso.current.value = '9';
                        setChek(9);
                    }
                    txtReferencia.current.value = props.compro.referencia;

                    txtFecha.current.value = moment.utc(props.compro.fecha).format('YYYY-MM-DD');
                    txtIdprov.current.value = props.compro.idproveedor;
                    seleccionarProveedor(props.compro.idproveedor);
                    txtIdCoordinacion.current.value = props.compro.idcoordinacion;
                    seleccionarUnidadEjecutora(props.compro.idcoordinacion);
                    setDatospre(props.cuentas);
                    //txtNombreOr.current.value = props.provee.razonsocial.trim();
                    //txtNTraslado.current.value = '000' + props.compro.codigo;
                    seleccionarReferencia(props.compro.tipo, props.operacion);*/

          if (props.cuentas.length > 0) {
            setValida(1);
            setValidat(1);
            setDeshabi(true);
          }
        } else {
          seleccionaUltimoId();
          //txtTipoCompromiso.current.value = '1';
          //setTipo(5);
          //setValidatipo('1');
          setHabicatb(false);
          setHabicat(false);
          //setEstatatus(1);
          //setTipoOrden(0);
          setDeshabilitado(true);
          setHabiProv(true);
          setHabiUni(true);
          setHabiConcep(true);
          setHabiFecha(false);
          txtFechaAjuste.current.value =
            moment.utc(fechaSistema).format("YYYY-MM-DD");
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {props.operacion === 1
              ? props.titulo
              : props.operacion === 2
              ? props.titulo
              : props.operacion === 3
              ? props.titulo
              : props.titulo}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
        <input type="hidden" ref={txtNp} />
        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap gap-2 border-azul rounded">
          <legend className="float-none m-0 w-auto">Datos</legend>

            {((props.operacion === 1 && chek === 6) || chek === 7) && (
              <div className="col-3 m-0 p-0">
                <Input
                  label={
                    chek === 6 ? "Monto Fondo Avance:" : "Monto Fondo Anticipo:"
                  }
                  type="text"
                  className="form-control text-right"
                  disabled={true}
                  ref={txtMontoFondo}
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="idcompromiso"
                  defaultValue={"0,00"}
                />
              </div>
            )}

            <div className="col-3 m-0 p-0">
            <Input
                label="Codigo Ajuste Compromiso"
                onKeyUp={handleInputNumChange}
                disabled={habiCod}
                id="idajuste"
                ref={txtCodigo}
            />
            </div>
            <div className="col-3 m-0 p-0">
            <SearchInput
                label="Compromiso N°"
                type="text"
                autocomplete="off"
                className="form-control text-uppercase"
                onKeyUp={handleCompromiso}
                onChange={onChange}
                disabled={habicat}
                name="idcompromiso"
                id="ref"
                disabledButton={habicatb}
                onClickButton={catalogoCompromiso}
                ref={txtIdCompromiso}
            />
            </div>
            <div className="col-3 m-0 p-0">
            <Input
                label="Fecha Ajuste"
                disabled={habiFecha}
                defaultValue={
                props.ajuste && props.ajuste.fechaajuste !== ""
                    ? moment.utc(props.ajuste.fechaajuste).format("YYYY-MM-DD")
                    : moment.utc(fechaSistema).format("YYYY-MM-DD")
                }
                id="inputDireccion"
                ref={txtFechaAjuste}
            />
            </div>
            <div className="col-12 m-0 p-0">
            <Textarea
                label="Observación Ajuste"
                style={{ height: 70 }}
                autocomplete="off"
                name="observacionajuste"
                onChange={onChange}
                disabled={
                props.operacion === 4 ||
                props.operacion === 5 ||
                props.operacion === 2
                    ? true
                    : false
                }
                defaultValue={
                props.ajuste ? props.ajuste.observacionajuste.trim() : ""
                }
                placeholder="Describa la Observación"
                id="inputDireccion"
                ref={txtObservacionAjuste}
            />
            </div>
            <div className="col-3 m-0 p-0">
            <Select
                label="Tipo de Compromisos"
                onChange={onChange}
                name="tipo"
                disabled={true}
                ref={txtTipoCompromiso}
                options={[
                { value: "", label: "--Seleccione--" },
                { value: "1", label: "ORDEN DE COMPRA" },
                { value: "2", label: "PAGO DE OBRAS/SERVICIOS" },
                { value: "3", label: "ORDEN DE SERVICIO" },
                { value: "4", label: "PAGO DIRECTO" },
                { value: "5", label: "PAGO DE NOMINA" },
                { value: "6", label: "FONDO EN AVANCE" },
                { value: "7", label: "FONDO DE ANTICIPO" },
                { value: "9", label: "ORDEN DE" },
                ]}
            />
            </div>
            {/* {value: '8', label: 'FONDO DE RENTA'}, */}
            <div className="col-3 m-0 p-0">
            <Input
                label="N° de Referencia"
                autocomplete="off"
                onKeyUp={handleCompromiso}
                onChange={onChange}
                disabled={true}
                name="referencia"
                id="ref"
                ref={txtReferencia}
            />
            </div>
            <div className="col-3 m-0 p-0">
            <Input
                label="Fecha de Compromiso:"
                type="date"
                disabled={true}
                id="inputDireccion"
                ref={txtFecha}
            />
            </div>
            <div className="col-2 m-0 p-0">
            <Input
                label="Monto Ajuste:"
                disabled={true}
                id="idcompromiso"
                defaultValue={"0,00"}
                ref={txtMontoAjuste}
            />
            </div>

          <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
            <legend className="float-none m-0 w-auto ">Beneficiario</legend>
              <div className="col-2 m-0 p-0">
                <SearchInput label = 'Código:'
                    autocomplete="off"
                    onChange={handleProveedor}
                    disabled={
                      props.operacion === 4 ||
                      props.operacion === 5 ||
                      props.operacion === 2
                        ? true
                        : habiProv
                    }
                    id="inputDireccion"
                    onClickButton={catalogoProveedor}
                    disabledButton={
                        props.operacion === 4 ||
                        props.operacion === 5 ||
                        props.operacion === 2
                        ? true
                        : habiProv
                    }
                    ref={txtIdprov}
                />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                <Input label = 'RIF:' 
                    maxLength={12}
                    disabled={true}
                    id="inputDireccion"
                    ref={txtCedurifprov}
                />
              </div>
              <div className="col-8 m-0 p-0 pl-2">
                <Input label = 'Nombre:'
                    disabled={true}
                    id="inputDireccion"
                    ref={txtNombreprov}
                />
              </div>
          </fieldset>

          <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded ">
            <legend className="float-none m-0 w-auto ">Unidad Ejecutora</legend>
              <div className="col-2 m-0 p-0">
                <SearchInput label = 'Código:' 
                    autocomplete="off"
                    onChange={handleUnidadEjecutora}
                    disabled={
                      props.operacion === 4 ||
                      props.operacion === 5 ||
                      props.operacion === 2
                        ? true
                        : habiUni
                    }
                    id="inputDireccion"
                    ref={txtIdCoordinacion}
                    disabledButton={
                        props.operacion === 4 ||
                        props.operacion === 5 ||
                        props.operacion === 2
                          ? true
                          : habiUni
                      }
                    onClickButton={catalogoOrganismo}
                />
              </div>
              <div className="col-10 m-0 p-0 pl-2">
                <Input label = 'Nombre:'
                    disabled={true}
                    id="inputDireccion"
                    ref={txtNombreUnidad}
                />
              </div>
          </fieldset>

          <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
            <div className="col-6 m-0 p-0 pr-1">
                <Textarea label= 'Concepto/Detalles' 
                    style={{ height: 70 }}
                    name="concepto"
                    onChange={onChange}
                    disabled={habiConcep}
                    defaultValue={
                        props.compro ? props.compro.concepto.trim() : ""
                    }
                    placeholder="Describa el Concepto o Detalle"
                    id="inputDireccion"    
                    ref={txtConcepto}
                />
            </div>
            <div className="col-6 m-0 p-0 pl-1">
                <Textarea label= 'Observaciones' 
                    style={{ height: 70 }}
                    name="observacion"
                    onChange={onChange}
                    disabled={true}
                    defaultValue={
                        props.compro ? props.compro.observacion.trim() : ""
                    }
                    placeholder="Describa la Observación"
                    id="inputDireccion"
                    ref={txtObservacion}
                />
            </div>
          </fieldset>
        </fieldset>

        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
          <legend className="float-none m-0 w-auto ">Codificación</legend>
            <TablaCodificacionAjusteCompromiso
              data={BaseDatos}
              datarecords={datospre}
              operacion={props.operacion}
              validaboton={deshabi}
              tipo={tipo}
              exento={exento}
              idprov={txtIdprov.current ? txtIdprov.current.value : ""}
              nmonacompro={monaCompro}
            />
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={onChangeValidar}
          disabled={props.operacion === 4 ? true : false}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
        {props.ajuste && props.operacion !== 1 && (
          <InfoButton onClick={imprimiAjusteCompromiso} icon="fa-print">
            Imprimir
          </InfoButton>
        )}
      </Modal.Footer>
      <CatalogoUnidadEjecutora
        show={mostrar3}
        onHideCancelar={handleCancelara}
        onHideAceptarUnidad={handleAceptaUnidadEjecutora}
      />
      <CatalogoProveedorPresupuesto
        show={mostrar4}
        onHideCancelar={handleCancelaProveedor}
        onHideAceptaProveedor={handleAceptarProveedor}
      />
      <CatalogoCompromisosUbicacion
        show={mostrar5}
        proce={0}
        ubicacion={42}
        reversado={0}
        status={0}
        idefiscal={idefiscal}
        onHideCancelar={handleCancelaCompromisos}
        onHideAceptarCompromiso={handleAceptarCompromisos}
      />
      <CatalogoObrasAsignada
        show={mostrar8}
        status={0}
        onHideCancelar={handleCancelaObra}
        onHideAceptaObra={handleAceptarObra}
      />
      <CatalogoSPagoNomiAprob
        show={mostrar6}
        status={0}
        onHideCancelar={handleCancelaSpagosNomi}
        onHideAceptaSolicitudes={handleAceptarSPagosNomi}
      />
      <CatalogoFondoAvanceAprob
        show={mostrar7}
        condicion={condicion}
        onHideCancelar={handleCancelaFondos}
        onHideAceptaFondos={handleAceptarFondos}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito." || mensaje.titulo === "Notificación."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={handleCloseNo}
        onHideSi={handleCloseSi}
      />
      <ValidarUsuario
        show={mostrarUsuario}
        onHideCancela={() => {
          setMostrarUsuario(false);
        }}
        onHideConfirmar={aceptaClaveSupervisor}
        llamado={2}
      />
      <CambiodeDatos
        show={cambiarDatos}
        onHideCancela={() => {
          setCambiarDatos(false);
        }}
        onHideConfirmar={aceptaCambioDatos}
        llamado={llamado}
        codigo={txtCodigo.current ? txtCodigo.current.value : ""}
        fecha={fecha}
      />
    </Modal>
  );
};
